module.exports = __webpack_public_path__ + "static/media/loader.e80b33ff.gif";